import { Button } from '@lastbrand/web-ui/button'
import { TFunction, useTranslation } from 'next-i18next'
import React from 'react'

import { useFormatPrice } from '@src/blocks/currency'
import { OptionProp } from '@src/quince-site-pdp/src/atoms/optionSelector/OptionSelector.constant'

import { packButtonCss, packItemPriceClass, packSelectedCss } from './pack-option-ds.styles'

type FormatPriceFn = ReturnType<typeof useFormatPrice>

type PackOptionDSProps = {
  value: string
  quantityInPack?: number
} & Pick<OptionProp, 'isSelected' | 'salePrice' | 'className'>

/**
 * Outlined pack chip via `@lastbrand/web-ui` `Button`. The chip is display-only — it
 * does NOT wire `onChange`, so it fires no variant-select event (matches legacy).
 */
const PackOptionDS = ({ value, quantityInPack, isSelected, salePrice }: PackOptionDSProps) => {
  const { t } = useTranslation('common')
  const formatPrice = useFormatPrice()
  return (
    <Button variant="secondary" size="md" css={isSelected ? { ...packButtonCss, ...packSelectedCss } : packButtonCss}>
      {renderButtonValue(value, salePrice, quantityInPack, t, formatPrice)}
    </Button>
  )
}

const renderButtonValue = (
  value: string,
  salePrice: number | undefined,
  quantityInPack: number | undefined,
  t: TFunction,
  formatPrice: FormatPriceFn,
) => {
  const salePriceValue = salePrice && (Math.round(salePrice * 100) / 100).toFixed(2)
  const priceForEachItem = salePriceValue && quantityInPack && (parseFloat(salePriceValue) / quantityInPack).toFixed(2)

  return (
    <>
      <span>
        {value} {salePriceValue && formatPrice(salePriceValue)}
      </span>
      {priceForEachItem && (
        <span className={packItemPriceClass}>{t('var1_ea', { var1: formatPrice(priceForEachItem) })}</span>
      )}
    </>
  )
}

const PackOptionDSWithOptionValue = ({ optionValue, ...props }: OptionProp) => {
  return <PackOptionDS value={optionValue.value} quantityInPack={optionValue.quantityInPack} {...props} />
}

export default PackOptionDSWithOptionValue
